import { Category, ID } from "../../types/server";
import types from "./types";
import utils from "./utils";

// TODO : We should extend Category and put actual
// products.
export type CategoriesState = {
  [k in ID]: Category;
};
export const init_state: CategoriesState = null;

export default function categoiresReducer(state = init_state, action) {
  switch (action.type) {
    case types.SET_CATEGORIES:
      return utils.with_products(
        action.payload.categories,
        action.payload.products
      );
    default:
      return state;
  }
}
